// 组件对象，大写
import treeEditRole from './treeEditRole.vue'
export default treeEditRole
